/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RewardsProgressModule_tradeFirm$ref: FragmentReference;
export type RewardsProgressModule_tradeFirm = {|
  +loyalty: ?{|
    +rewards: ?string,
    +nextReward: ?string,
    +nextRewardAmount: ?string,
    +remainingAmount: ?string,
    +progressToNextReward: ?number,
  |},
  +$refType: RewardsProgressModule_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "RewardsProgressModule_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "loyalty",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmLoyaltyType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "rewards",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "nextReward",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "nextRewardAmount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "remainingAmount",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "progressToNextReward",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '54c2191394da932f1d5f72ce5f0e8138';
module.exports = node;
